import type { GetCurrencyConversionByCodeQuery } from '../Card.graphql.generated';
import { useGetCurrencyConversionByCodeQuery } from '../Card.graphql.generated';
import { DEFAULT_CURRENCY } from '@shared/utils/currency/constants';

/**
 * Base currency: USD
 */
export type CurrencyRateData = Readonly<{
  /** Exchange rate from USD to this currency */
  exchangeRate: number;
  /** Price increase multiplier (e.g., 1.10 = 10% increase, 1.20 = 20% increase) */
  taxesAndFeesMultiplier: number;
  /** Fixed cost per card in minor units */
  fixedCostPerCardInMinorUnits: number;
}>;

export const useCurrencyConversionRate = (currency: string = ''): { data: GetCurrencyConversionByCodeQuery['currencyConversionByCode'] | undefined; loading: boolean } => {
  const { data, loading } = useGetCurrencyConversionByCodeQuery({
    variables: { currencyCode: currency },
    batchMode: 'fast',
    // Skip if currency is not set or is the default currency.
    // There's no point in fetching the currency conversion rate for the default currency.
    skip: !currency || currency === DEFAULT_CURRENCY,
  });

  return { data: data?.currencyConversionByCode, loading };
};
